
export class Filtro {

  constructor(public id: string, public titulo: string, public tipo: string, public total: number, public operador:string, public ordenamiento?:string){
  }
}
